/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListMessageResponse = {
    properties: {
        messages: {
    type: 'array',
    contains: {
        type: 'SmsMessage',
    },
    isRequired: true,
},
        nextPageToken: {
    type: 'string',
    isRequired: true,
    isNullable: true,
},
        pageSize: {
    type: 'number',
    isRequired: true,
},
    },
};